import React from 'react';

import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import DownloadIcon from '@mui/icons-material/Download';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import {
  Button,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import NoticeHistory from './History';
import { NoticeController, init } from './noticeController';
import * as selectors from './selector';

import PdfViewer from '@/components/PdfViewer';
import Title from '@/components/Title';
import { LastModifiedDatetime } from '@/domain/notice/service/entity/valueObjects/lastModifiedDatetime';

const Notice: React.FC = () => {
  const dispatch = useDispatch();
  const nurseryId = useSelector(selectors.nurseryIdSelector);
  const isInitCategoryItems = useSelector(selectors.isInitCategoryItemsSelector);
  const categoryList = useSelector(selectors.categoryListSelector);
  const categoryItems = useSelector(selectors.categoryItemsSelector);
  const content = useSelector(selectors.contentSelector);
  const [categoryId, setCategoryId] = React.useState<string | undefined>(undefined);
  React.useEffect(
    () => init(dispatch, nurseryId, isInitCategoryItems),
    [dispatch, nurseryId, isInitCategoryItems],
  );
  if (!nurseryId) {
    return (
      <div>
        <Title title="掲示板" />
        <div style={{ marginTop: '10px' }}>
          表示する施設がありません。
        </div>
      </div>
    );
  }
  if (!categoryItems) {
    return (
      <div>
        <Title title="掲示板" />
        <div style={{ marginTop: '10px' }}>
          Loading...
        </div>
      </div>
    );
  }

  const controller = new NoticeController(dispatch, nurseryId, categoryList, categoryItems);
  const categories = controller.getCategories();
  const contents = [];
  for (let i = 0; i < categories.length; i += 1) {
    const data = categories[i];
    const { items, limit } = controller.getNoticeItems(data);
    const content = [];
    if (limit > 0) {
      for (let j = 0; j < limit; j += 1) {
        const item = items[j];
        const date = LastModifiedDatetime.create(new Date(item.lastModifiedDatetime));
        const updateType = item.lastModifiedDatetime === item.createDatetime ? '掲載' : '更新';
        content.push(
          <ListItem
            key={`item${i}_${j}`}
            sx={{ pl: 4 }}
          >
            <ListItemButton onClick={
              controller.getActionSetPreview(item.categoryId, item.createDatetime)
            }
            >
              <ListItemIcon>
                <ArrowRightIcon />
              </ListItemIcon>
              <ListItemText
                primary={item.title}
                secondary={`${date.toStringDateDisplay()} ${updateType}`}
              />
            </ListItemButton>
            <Button
              onClick={controller.getActionDownload(item.categoryId, item.createDatetime)}
              color="inherit"
            >
              <DownloadIcon />
            </Button>
          </ListItem>,
        );
      }
      contents.push(
        <div key={`category${i}`} style={{ marginTop: '10px' }}>
          <ListItem
            sx={{ bgcolor: 'select' }}
          >
            <ListItemIcon>
              <HistoryEduIcon />
            </ListItemIcon>
            <ListItemText primary={data.category} />
          </ListItem>
          <Divider />
          <List component="div" disablePadding>
            {content}
            <ListItem>
              <ListItemText primary="" />
              <Button
                onClick={() => setCategoryId(data.categoryId)}
              >
                過去のお知らせ
              </Button>
            </ListItem>
          </List>
        </div>,
      );
    }
  }

  return (
    <div>
      <Title title="掲示板" />
      <div>
        {contents.length > 0 ? (
          <List>
            {contents}
          </List>
        ) : (
          <p>掲示物がありません</p>
        )}
      </div>
      {nurseryId && categoryId && (
        <NoticeHistory
          nurseryId={nurseryId}
          categoryId={categoryId}
          close={() => setCategoryId(undefined)}
        />
      )}
      {content?.attachment && (
        <PdfViewer
          isOpen
          attachment={content.attachment}
          close={controller.getActionSetPreview(undefined, undefined)}
        />
      )}
    </div>
  );
};

export default Notice;
